module.exports = __webpack_public_path__ + "img/clients-sidebar.24c9177e.svg";